import { render, staticRenderFns } from "./previewForm.vue?vue&type=template&id=f6d829c8&scoped=true&"
import script from "./previewForm.vue?vue&type=script&lang=js&"
export * from "./previewForm.vue?vue&type=script&lang=js&"
import style0 from "./previewForm.vue?vue&type=style&index=0&id=f6d829c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d829c8",
  null
  
)

export default component.exports